import axios from 'axios';
import { attemptRefresh } from './RefreshTimer';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL ?? window.location.origin,
  timeout: 10000,
});

axiosInstance.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    return config;
  }
  config.headers["Content-Type"] = "application/json";
  return config;
});

let isRefreshing = false;
let failedQueue = [];
let debounceTimer = null;

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && debounceTimer) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      });
    }

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== '/auth/refresh'
    ) {
      clearTimeout(debounceTimer);
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        });
      }
      isRefreshing = true;
      try {
        const refreshed = await attemptRefresh();
        if (refreshed) {
          originalRequest.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
          processQueue(null, localStorage.getItem('token'));
          return axiosInstance(originalRequest);
        } else {
          processQueue(error, null);
          return Promise.reject(error);
        }
      } catch (refreshError) {
        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
